import React, { useEffect, useState } from "react";
import Deleteicon from "../../assets/icons/popup/Check Icon.svg?react";

export default function SuccessPopup({ isOpen, onClose }) {
  const [isVisible, setIsVisible] = useState(isOpen);
  const [isAnimating, setIsAnimating] = useState(false);

  // Manage smooth open and close animations
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10); // Small delay to trigger transition
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => setIsVisible(false), 300); // Wait for animation to finish
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50  transition-opacity duration-300 ${
          isAnimating ? "opacity-100" : "opacity-0"
        }`}
      >
        <div
          className={`w-full max-w-sm bg-white rounded-md px-12 py-5  text-center transform transition-all duration-300  ease-in-out ${
            isAnimating ? "scale-100 opacity-100" : "scale-95 opacity-0"
          }`}
        >
          {/* Warning Icon */}
          <div className="mb-2.5 inline-flex">
            <div className=" rounded-full flex items-center justify-center">
              <Deleteicon className=" object-cover " />
            </div>
          </div>

          {/* Message */}
          <h3 className="text-2xl font-semibold text-[#1AC057] mb-2.5">
            Success!
          </h3>
          <p className="text-base font-normal text-gray-900 mb-2.5">
            User successfully updated!
          </p>

          {/* Buttons */}
          <div className="flex gap-3 justify-center">
            <button
              onClick={onClose}
              className=" px-[22px] py-2.5 text-sm bg-[#0E64D1] text-white rounded-md hover:bg-blue-600 transition-colors"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
